import React, { useMemo } from 'react';
import { AppId, FCX, ProductLogo, usePlatformContext } from '@datassential/platform-ui-lib';
import { useMacsPermissionLevel } from '@apiHooks/useMacsPermissionLevel';
import { PermissionLevelEnum } from '@models/PermissionSection';
import { iReportProPublication } from '@models/ReportProPublication';
import { Grid } from '@components/new/Grid/Grid';
import CategoryProfileSubtitle from '@pages/CategoryProfile/components/CategoryProfileSubtitle/CategoryProfileSubtitle';
import AccessLink from '@components/AccessLink/AccessLink';
import PublicationCard, { PublicationCardTooltip } from '@components/PublicationCard/PublicationCard';
import { sanitizeUrl } from '@helpers';
import { routeNames } from '@core/routeNames';
import dsPlaceholderLogo from '../../../../../../img/ds-placeholder-logo.svg';
import './TrendingNowMacs.styles.scss';

interface TrendingNowMacsProps {
	macs: iReportProPublication[];
}

const TrendingNowMacs: FCX<TrendingNowMacsProps> = ({ macs, className, style, testId }) => {
	const { data: permissionLevel } = useMacsPermissionLevel();
	const hasAccess = useMemo(() => permissionLevel === PermissionLevelEnum.Full, [permissionLevel]);
	const { userInfo: { snapUiUrl, snapMacUrl } } = usePlatformContext();
	const detailsPath = sanitizeUrl(`${snapUiUrl}/${snapMacUrl}`);

	return (
		<>
			<div
				className={`TrendingNowMacs ${className ?? ''}`}
				style={style}
				data-testid={testId || 'blockCategoryProfileTrendingNowMacs'}
			>
				<div className="TrendingNowMacs__container">
					<CategoryProfileSubtitle>MAC</CategoryProfileSubtitle>
					{macs.length === 0 && (
						<div className="TrendingNowMacs__loading">
							<div className="spinner spinner-blink">
								<ProductLogo appId={AppId.Snap} type="regular" />
							</div>
						</div>
					)}
					<div className="TrendingNowMacs__grid">
						<Grid itemWidth={230} maxRowsCount={1}>
							{macs.map((item, index) => ({
								key: item.id,
								value: (
									<React.Fragment>
										<PublicationCard
											className={`CategoryProfileTrendingNowMacCard${!hasAccess ? ' CategoryProfileTrendingNowMacCard--locked' : ''}`}
											data={item}
											index={index}
											link={hasAccess ? `${detailsPath}${item.id}` : ''}
											tooltipId={`category-profile-mac-${item.id}`}
											testIdBase="CategoryProfileTrendingNowMacCard"
											placeholder={<img src={dsPlaceholderLogo} alt="" />}
										/>
										<PublicationCardTooltip
											className="TrendingNowMacs__card-tooltip"
											data={item}
											index={index}
											tooltipId={`category-profile-mac-${item.id}`}
											testIdBase="CategoryProfileTrendingNowMacCard"
										/>
									</React.Fragment>
								),
							}))}
						</Grid>
					</div>
				</div>
			</div>
			<AccessLink
				url={sanitizeUrl(`${snapUiUrl}/${routeNames.trendingNow}#section-mac`)}
				text="More Trending Now"
				testId="linkCategoryProfileMoreTrendingNow"
			/>
		</>
	);
};

export default TrendingNowMacs;
